/**
 * Folds a label to compare it the way Voice does: the same rule as
 * `normalizeForMatch` in Voice `campaign.service.ts` (NFD, no combining marks,
 * lowercase, whitespace collapsed, trimmed). Keep them in sync.
 *
 * Its own module so `resultsHeaders.ts` can use it without importing the
 * catalogue (`objectives.ts` imports `resultsHeaders.ts`).
 */
export function foldOutcomeLabel(label: string): string {
  return label
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/\s+/g, ' ')
    .trim();
}
